<template>
  <div class="user-page">
    <EditUserDialog :dialogType="dialogIndex" @onClose="onCloseDialog" v-if="dialogShow" />
    <div class="page-title">{{$t("accountTitle")}}</div>
    <div class="accountInfo">
        <div class="item" style="height: 70px;">
          <div class="title">{{$t("accountUserAvatar")}}</div>
          <div class="userAvatar">
            <UserAvatar :size="36" :defaultSize="36" />
          </div>
        </div>
        <div class="line" />
        <div class="item">
          <div class="title">{{$t("accountUserName")}}</div>
          <div class="subTitle">{{userInfo.nickName}}</div>
          <div class="rightDiv">
            <div class="otherTitle" @click="onEditUserName">{{$t("accountChange")}}</div>
          </div>
        </div>
        <div class="line" />
        <div class="item">
          <div class="title ">{{$t("accountUserLogin")}}</div>
          <div class="subTitle ">{{userInfo.userAccount}}</div>
        </div>
        <div class="line" />
        <div class="item" v-if="userInfo.showModifyPassword">
          <div class="title">{{$t("accountUserPassword")}}
            <div class="red-point-account" v-if="userInfo.setPasswordWarn" />
          </div>
          <div class="subTitle">{{userInfo.setPasswordWarn ? $t("accountUnSetting") :
            $t("accountSetting")}}</div>
          <div class="rightDiv">
            <div class="otherTitle" @click="onEditUserPassword">{{$t("accountChange")}}</div>
          </div>
        </div>
        <div class="line" />
        <div class="item">
          <div class="title">{{$t("accountNotiEmail")}}
            <div class="red-point-account" v-if="!userInfo.email" />
          </div>

          <div class="subTitle hidden-xs-only hidden-sm-only">{{userInfo.email}}</div>
          <div class="rightDiv">
            <div class="otherTitle" style="margin-left: 10px;" @click="onEditUserEmail">{{ userInfo.email ?
              $t("accountChange") : $t("setting")}}</div>
          </div>
        </div>
        <div class="item rightDiv">
          <div class="title">{{$t("accountNotiEmail_switch")}}
            <!-- <div class="red-point-account" v-if="!userInfo.email"/> -->
          </div>
          <div class="">
            <Switch class="u-theme-switch" switchWidth="28px" switchHeight="14px" @change="onEmailChange"
              v-model:checked="closeEmailFlag"
              :node-style="{ background: closeEmailFlag ? 'linear-gradient( 180deg, #04FFFF 0%, #2468FF 100%)' : '#BFBFBF' }"
              :bgStyle="{ background: closeEmailFlag ? '#D3E9F9' : '#F5F5F5' }" />
            <!-- <div class="otherTitle" style="margin-left: 10px;" @click="onEditUserEmail">{{ userInfo.email ? $t("accountChange") : $t("setting")}}</div> -->
          </div>
        </div>
        <div class="line" />
        <div class="item">
          <div class="title">{{ $t('dcolingo_bilingualMode_switch') }}</div>

          <div class="subTitle compare_switch_view">
            <el-radio-group v-model="compareStyleType" @change="onCompareStyleChange">
              <el-radio :value="0" size="large">{{ $t('dcolingo_paragraph_comparison')}}</el-radio>
              <el-radio :value="1" size="large">{{ $t('dcolingo_spa_mode') }}</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="line" v-if="userInfo.accountType === 0" />
        <div class="delete-account">
          <span class="delete-title" @click="onDeleteAccount">
            {{$t(`accountSignOut`)}}
          </span>
        </div>
        <!-- <div class="item" v-if="accountSign === '1'">
          <div class="signOut">
            <div class="signBtn" @click="onSignOut">
              {{$t(`accountSignOut`)}}
            </div>
          </div>
        </div> -->

      </div>
  </div>
</template>

<script setup lang="ts">
import AccountServer from '~/services/AccountServer'
import EditUserDialog from '~/components/Translate/Dialog/EditUserDialog.vue'
import { type FileItem } from '~/services/AccountServer/types'
import EventBus from 'vue3-eventbus'
import { NetCode } from '~/types/const'
import useUserStore from '~/store/modules/user'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import Switch from '~/components/Switch/Switch.vue'
import UserServer from '~/services/UserServer'
import Toast from '@/utils/toast'

const tableData = ref<FileItem[]>([])
const userStore = useUserStore()
const { userInfo, userRights} = storeToRefs(userStore)
const {t} = useI18n()
const dialogShow = ref(false)
const dialogIndex = ref(0)
let closeEmailFlag = ref(false)
let checked = ref(false)
let emailChecked = ref()
let compareStyleType = ref(0)
const logOutShow = ref(false)
const accountSign = ref("")
const params = {
  pageSize: 4,
  pageNo: 1,
  pageTotalSize: 0,
  recordIds: null as number[] | null,
  prevPageId: null as number | null,
  nextPageId: null as number | null
}

watch(
    () => userInfo.value,
    () => {
      emailChecked.value = userInfo.value.subVipEmailNoticeFlag == 0 ? false : true
      closeEmailFlag.value = userInfo.value.closeEmailFlag == 0 ? true : false
      compareStyleType.value = userInfo.value.transCompareStyleType ? userInfo.value.transCompareStyleType : 0
    },
    {
      deep: true
    }
)

function onDeleteAccount() {
  dialogShow.value = true
  dialogIndex.value = 4
}

function onEditUserName() {
  dialogShow.value = true
  dialogIndex.value = 0
  nextTick(()=>{
    let input = document.getElementById('nameInput');
    console.log("document", input)
    if (input) {
      input.select()
    }
  })
}

function onEditUserPassword() {
  dialogShow.value = true
  dialogIndex.value = 1
}

function onEditUserEmail() {
  dialogShow.value = true
  dialogIndex.value = 2

  nextTick(()=>{
    let input = document.getElementById('emailInput');
    console.log("document", input)
    if (input) {
      input.select()
    }
  })
}

function onCloseDialog() {
  dialogShow.value = false
  logOutShow.value = false
  // payDialogShow.value = false
}

function onEmailChange() {
  let value = closeEmailFlag.value ? 0 : 1
  UserServer.getAccountInfoEdit({closeEmailFlag: value}).then((data)=> {
    if (data.code == "1") {
      userInfo.value.closeEmailFlag = value
      // userInfo.value.subVipEmailNoticeFlag = value
    }else {
      userInfo.value.closeEmailFlag = value
    }
  }).catch((error)=>{
    userInfo.value.closeEmailFlag = value
  })
}

// 切换双语模式事件
const onCompareStyleChange = () => {
  let params = {
    compareStyleType: compareStyleType.value
  }
  UserServer.getModifyCompareCfgApi(params).then((data) => {
    if (data.code == "1") {
      Toast(t('dcolingo_switch_success'))
    }
  }).catch((error) => {
    
  })
}

function onRequestSignOutConfig() {
  UserServer.getRequestConfigById({thisId: "33"}).then((data)=> {
    if (data.code == "1") {
      accountSign.value = data.data.param
      console.log("onRequestSignOutConfig",accountSign.value)
    }
  }).catch((error)=>{

  })
}

onUnmounted(()=>{
  
})

onMounted(()=>{
  onRequestSignOutConfig()

  emailChecked.value = userInfo.value.subVipEmailNoticeFlag
  checked.value = userRights.value.checkSameFileSwitch == "0" ? false : true
  closeEmailFlag.value = userInfo.value.closeEmailFlag == 0 ? true : false
})

</script>

<style lang="scss" scoped>
.user-page {
  max-width: 100%;
}

.accountInfo {
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  .item {
    display: grid;
    align-items: center;
    height: 56px;
    border-bottom: 1px solid #F2F2F2;
    grid-template-columns: 20% 70% 10%;
    .userAvatar {
      display: flex;
      align-items: center;
      justify-content: start;
    }
    .rightDiv {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .otherTitle {
        color: #2690E1;
        font-size: 12px;
        cursor: pointer;
      }
    }
  }
  .delete-account {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 56px;
  
    .delete-title {
      color: #8C8C8C;
      font-size: 12px;
      cursor: pointer;
      &:hover {
        opacity: 0.7;
      }
    }
  }
  .nameEmail{
    margin-left: 4px;
    .title {
      max-width: 70px;
      font-size: 12px;
      color: #595959;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;

    }
    .subTitle {
      max-width: 150px;
      font-size: 12px;
      color: #262626;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  .arrow {
    flex: 1;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    .red-point-account {
      display: flex;
      flex-direction: row-reverse;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #E14C25;
      margin-right: 10px;
    }
  }
  .title {
    color: #595959;
    font-size: 12px
  }
  .subTitle {
    color: #262626;
    font-size: 12px
  }
}
.page-header {
  
}

.page-title {
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  margin: 0;
}

.user-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid #BFBFBF;
  margin-top: 40px;
}

</style> 